// HEADER JS START

document.addEventListener('DOMContentLoaded', function () {
  const menuItems = document.querySelectorAll('header-menu > details');

  menuItems.forEach((item) => {
    const summary = item.querySelector('summary');

    // Open on mouseenter
    item.addEventListener('mouseenter', () => {
      item.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    // Close on mouseleave
    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    });
  });
});

// HEADER JS END

// document.addEventListener("DOMContentLoaded", function () {
//   const iframe = document.querySelector("#iframe-container > kickflip-customizer-iframe").shadowRoot.querySelector("iframe");

//   iframe.onload = function () {
//     const input = iframe.contentWindow.document.querySelector(".bulk-order-quantity-input");

//     if (input) {
//       input.value = 50; // change value
//     } else {
//       console.warn("Input not found in iframe.");
//     }
//   };
// });

